import script from "./AccordionItemResourceAndSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionItemResourceAndSkills.vue?vue&type=script&setup=true&lang=js"

import "./AccordionItemResourceAndSkills.vue?vue&type=style&index=0&id=9d9f8d9c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d9f8d9c"]])

export default __exports__